export const accountLinkage = {
    maxLinkedAccountsCount: 1,
    minLinkedAccountsCount: 1,
};
